<template>
  <Collapse
    class="green-operation__assessment green-operation__no-bottled"
  >
    <template #title>
      <HKLLeftRight>
        <span class="font-bold">{{ $t('tenancy.greenOperation.assessments.noBottled.title') }}</span>
        <HKLInputPoints
          v-model="points"
          :isEdit="false"
          v-if="!isEdit && canViewPoint"
        />
      </HKLLeftRight>
    </template>
    <template #content>
      <div>
        <HKLLeftRight class="green-operation__assessment-title">
          <span class="font-bold">
            {{ $t('tenancy.greenOperation.assessments.noBottled.waterDispensingMachine') }}
          </span>
          <HKLInputPoints
            v-model="waterDispensingMachine.point"
            :isEdit="isEdit"
            v-if="canViewPoint"
          />
        </HKLLeftRight>
        <div class="green-operation__assessment-form row">
          <template v-if="isTenant">
            {{ waterDispensingMachineHint }}
          </template>
          <template v-else>
            <HKLRadioButton
              v-for="(option, index) in optionMap.waterDispensingMachine"
              v-model="waterDispensingMachine.value"
              :key="index"
              :disabled="!isEdit"
              :value="option.value"
              class="small-4"
            >
              {{ option.label }}
            </HKLRadioButton>
          </template>
        </div>
      </div>
      <HKLTable
        v-bind="tableAttrs"
        v-if="tableAttrs.dataSource.length > 0"
      />
    </template>
  </Collapse>
</template>

<script>
import { toRefs, reactive, computed, unref } from 'vue-demi'
import Collapse from '@/controls/Collapse.vue'
import HKLTable from '@/controls/Table/HKLTable.vue'
import HKLLeftRight from '@/controls/Layout/HKLLeftRight.vue'
import HKLRadioButton from '@/controls/Button/HKLRadioButton.vue'
import { useStoreGetters } from '@/store/index'
import HKLInputPoints from '../components/HKLInputPoints.vue'
import { useGreenOperationField, useGreenOperationAssessmentFormStatus } from '../hook'
import { GREEN_OPERATION_ASSESSMENT_TYPE } from '../consts'
import { useAssessmentDocumentTableAttrs, useAssessmentForm } from './hook'
import { totalPoints } from './utils'
import { useGreenOperationPerms } from '../GreenOperationLetter.hook'
import i18n from '@/utils/i18n'

const ASSESSMENT_TYPE = GREEN_OPERATION_ASSESSMENT_TYPE.NO_BOTTLE

export default {
  components: {
    Collapse,
    HKLTable,
    HKLLeftRight,
    HKLRadioButton,
    HKLInputPoints,
  },
  setup () {
    const sourceId = useGreenOperationField('id', '')
    const { isEdit } = useGreenOperationAssessmentFormStatus()
    const { isTenant } = useStoreGetters('user', ['isTenant'])
    const { canViewPoint } = useGreenOperationPerms()
    const tableAttrs = useAssessmentDocumentTableAttrs(sourceId, ASSESSMENT_TYPE)
    const optionMap = computed(() => ({
      waterDispensingMachine: [
        {
          label: i18n.t('action.yes'),
          value: 'yes',
        },
        {
          label: i18n.t('action.no'),
          value: 'no',
        },
      ],
    }))
    const formMap = reactive({
      waterDispensingMachine: useAssessmentForm(
        ASSESSMENT_TYPE,
        'waterDispensingMachine',
      ),
      waterDispensingMachineHint: computed(() => {
        const options = unref(optionMap).waterDispensingMachine
        const currentValue = unref(formMap.waterDispensingMachine).value
        const option = options.find((option) => option.value === currentValue)
        return option ? option.label : i18n.t('emptyValue')
      }),
    })
    return {
      isEdit,
      isTenant,
      canViewPoint,
      tableAttrs,
      optionMap,
      ...toRefs(formMap),
      points: computed(() => totalPoints(formMap)),
    }
  },
}
</script>

<style lang="scss" scoped>
@import './common.scss';

</style>
